<div class="left">
   <div class="page-heading">
      <h1 class="page-type">{{ pageType }}</h1>
      <h2 class="page-title">{{ reportName }}</h2>
   </div>
</div>
<ndt-report-contextual-actions
   [allowConfigure]="showConfigureButton"
   [showDownloadOptions]="showDownloadOptions"
   [allowExcel]="allowExcel"
   [allowHtml]="allowHtml"
   [allowPdf]="allowPdf"
   [allowMemorize]="allowMemorize"
   [isLoading]="isLoading$ | async"
   (configure)="onConfigure()"
   (downloadExcel)="onDownloadExcel()"
   (downloadPdf)="onDownloadPdf()"
   (downloadHtml)="onDownloadHtml()"
   (saveParameters)="onSaveParameters()"
>
   <ng-content></ng-content>
</ndt-report-contextual-actions>
